// extracted by mini-css-extract-plugin
export default {"container":"RecipeLayeredIllustration_container__ZjUlI","layer":"RecipeLayeredIllustration_layer__SN42-"};